import { cva } from 'class-variance-authority';
export const durationPickerVariants = cva('relative flex rounded-xl bg-white border border-gray-100 overflow-hidden items-center focus-within:outline focus-within:outline-2 focus-within:outline-indigo-400 focus-within:outline-offset-2', {
    variants: {
        width: {
            full: 'w-full',
            fit: 'w-fit',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
export const durationPickerSectionVariants = cva('flex items-center px-3', {
    variants: {
        width: {
            full: 'flex-1 min-w-0',
            fit: '',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
export const durationPickerInputVariants = cva('text-left min-w-8 min-h-12 text-sm text-gray-700 placeholder:text-sm placeholder:text-gray-400 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none border-0', {
    variants: {
        width: {
            full: 'flex-1',
            fit: 'w-8',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
